<template>

  <div class="que-richtext">

    <!--<ul class="richtext-title">
      <li class="item">
        <i title="清除格式"></i>
      </li>
      <li class="item">
        <i title="加粗"></i>
      </li>
      <li class="item">
        <i title="无序排列"></i>
      </li>
      <li class="item">
        <i title="有序排列"></i>
      </li>
      <li class="item">
        <el-upload
          action=""
          :http-request="uploadImg"
          accept="image/jpeg,image/gif,image/png"
          :before-upload="beforeImgUpload"
          :show-file-list="false"
        >
          <i title="图片"></i>
        </el-upload>
      </li>
      <li class="item">
        <i title="视频"></i>
      </li>
      <li class="item">
        <i title="表情"></i>
      </li>
    </ul>-->
<!--    <editor-bar v-model="richtext" :isClear="isClear" ></editor-bar>-->


    <div class="tinymce-editor" id="fileupload">
      <input type="file"  name="files" id="upload_file_ipt" style="display: none" />
      <editor
              v-model="content"
              :init="init"
      >
      </editor>
    </div>


    <!-- 上传视频弹窗 -->
    <el-dialog
            title="上传进度"
            :visible.sync="dialogUploadVideo"
            top="100px"
            :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close ="false"
    >
      <div class="upload-video">
        <div class="pro">
          <el-progress class="video-progress"  :stroke-width="20" :percentage="processLenghth"></el-progress>
          <div class="text-tit">{{video.file_name}}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer cut-image">
<!--          @click="resumeCCUploadChunk" -->
        <!--           @click="pauseBJYUploadChunk"-->
            <el-button type="primary" icon="el-icon-video-play" title="继续" style="display: none" class="resumeObj"  v-if="processLenghth!=100"></el-button>
            <el-button type="primary" icon="el-icon-video-pause" title="暂停"  class="pauseObj"  v-if="processLenghth!=100"></el-button>
            <el-button type="primary" icon="el-icon-close" title="取消" class="cancelOjb" @click="closeVideoDialog"  v-if="processLenghth!=100"></el-button>
            <el-button type="primary" icon="el-icon-check" title="确定" @click="finishedUploadVideo" v-if="processLenghth==100"></el-button>
          </span>

    </el-dialog>

<!--    <el-input class="rich-cont" v-model="richtext" type="textarea" rows="6" :maxlength="500" show-word-limit :placeholder="placeholder" />-->
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios'
  import cch5upload from '@/utils/cch5/cch5upload'
  import $ from "jquery"
  import tinymce from "tinymce/tinymce";
  import Editor from "@tinymce/tinymce-vue";
  import "tinymce/themes/silver";
  // 编辑器插件plugins
  import 'tinymce/icons/default/icons'
  import "tinymce/plugins/preview"; // 预览插件
  import "tinymce/plugins/table"; // 插入表格插件
  import "tinymce/plugins/lists"; // 列表插件
  import "tinymce/plugins/image"; // 插入上传图片插件
  import "tinymce/plugins/media"; // 插入视频插件
  import "tinymce/plugins/wordcount"; // 字数统计插件
  import "tinymce/plugins/autolink";
  import "tinymce/plugins/link";
  import "tinymce/plugins/paste";
  import "tinymce/plugins/contextmenu";
  import  letterspacing from "@/utils/letterspacing/index.js"
  import  lineheight from "@/utils/lineheight/index.js"

  const setting ={
    selector: '#editor',
    media_live_embeds: true,
    file_picker_types: 'media',
    // 注册button
    toolbar: 'mybutton',
  };
export default {
  components: {
    Editor
  },
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: '问题描述'
    },
    baseUrl: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      //default: "lists link  image media table  wordcount fullscreen autolink "
      default: " lineheight letterspacing lists table  wordcount  autolink image media  "
    },
  },
  data () {
    return {
      init: {
        language_url: `http://i.renrendonghua.com/tinymce/langs/zh_CN.js`,
        language: "zh_CN",
        skin_url: `http://i.renrendonghua.com/tinymce/skins/ui/oxide`,
        content_css: `http://i.renrendonghua.com/tinymce/skins/content/default/content.css`,
        height: 300, //编辑器高度
        // width: 800,
        menubar: false, // 隐藏最上方menu
        plugins: this.plugins,
        //menubar: 'file edit format  insert removeformat ',
        //contextmenu: "copy | paste | link ",
        menu: {
          insert: {title: 'Insert', items: 'link media image  ccvideomenu'}
        },
        toolbar:  [
          'removeformat bold bullist numlist alignleft aligncenter alignright image media ccvideo',
        ],
        fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt", // 第二步
        font_formats:"微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        setup: function (editor) {
          // 注册一个工具栏按钮名称
          editor.ui.registry.addButton('ccvideo', {
            //text: '插入视频',
            tooltip:"插入视频",
            icon: 'non-breaking',
            onAction: function () {
              let input = document.getElementById("upload_file_ipt");

              input.setAttribute('type', 'file');
              input.setAttribute('accept', 'video/*');

              input.click();
            }
          }),
          // 注册一个菜单项名称 menu/menubar
          editor.ui.registry.addMenuItem('ccvideomenu', {
            //text: '插入视频',
            tooltip:"插入视频",
            text:"插入视频...",
            icon: 'non-breaking',
            onAction: function() {
              let input = document.getElementById("upload_file_ipt");

              input.setAttribute('type', 'file');
              input.setAttribute('accept', 'video/*');

              input.click();
            }
          })
        },
        branding: false,
        //隐藏插入视频 高级选项卡
        media_alt_source: false,
        media_poster: false,

        // 此处为图片上传处理函数
        images_upload_handler: (blobInfo, success, failure) => {
          let formData = new FormData();
          //data 为二进制的blob图片骗数据,//fileName 文件名
          formData.append('files', blobInfo.blob());
          axios.post('/open/upload/uploadImg',formData).then((res) => {
            success(res.data.url);
          }).catch(e => {
            console.log(e);
          })
        },

      },

      dialogUploadVideo:false,
      processLenghth:0,
      video:{
        file:"",
        video_id:'',
        file_name:'',
        upload_url:'', //上传地址
        re_upload_url:'', //续传地址
        file_size: '',
        file_type:'',
      },
      videoCcId:'',
      videoName:'',
      isClear :false,
        content: this.value,
      uploadLoading:false,
        testVal:'aaaaaaaaaa',
    }
  },
  beforeMount(){
    // 只会在浏览器执行
    this.$options.components.EditorBar = () =>import('@@/editoritem/editoritemforqa');
  },
  mounted () {
    tinymce.init({});
    this.ccinit()
    var this_  = this
  },
  methods: {

    ccinit(){
      var this_  = this
      var uploader = new CCH5Uploader({
        timeout : 180000, // 设置超时处理时间 超时时间3分钟 超时会重试
        maxChunkSize : 1024 * 1024, // 1M 最大不超过4M
        limitConcurrentUploads : 3, //并发上传文件数
        createInfoRetries:1,//调用用户创建视频信息接口重试次数,默认为5次
        maxRetries : 1, // 文件上传失败重试次数,默认10次
        retryTimeout : 500, //重试延迟时间（毫秒）
        autoUpload : true, //是否添加文件后自动上传
        fileInput :  $("#fileupload").find("input[type='file']"), //文件输入组件，必需要有的配置,可以是多个
        filesContainer : $('.videoFiles'), //上传文件记录显示的容器


        //上传失败重试指定次数后依然失败后的回调
        uploadFail : function(recordNode, fileName, failMsg) {
          //console.log("uploadFail================",failMsg);
          this_.stopUploadVideo()
        },
        progressStatus:function(status){
          //console.log("progressStatus================",status);
          this_.processLenghth = status
        },

        //上传成功回调,可不做任何处理
        //微信上传修改成功处理方法，后续需要用到，需要重写
        uploadSuccess : function(recordNode, fileName, ccvid,size) {
          // console.log(fileName + '上传成功'+"对应的视频id为：" + ccvid);
          // console.log(recordNode);

          this_.videoCcId = ccvid
          this_.videoName = fileName

          this_.finishedUploadVideo()
          this_.$message.success("上传成功")

        },

        // 生成视频信息
        createuploadinfo: function(fileName, fileSize){
          const isLt2G = fileSize / 1024 / 1024 < 2048
          if (!isLt2G) {
            this_.$message.error('上传视频大小不能超过 2G!')
            return false;
          }else{
            this_.dialogUploadVideo = true
          }

          let video = {};

          var d = {
            "title" : fileName,
            "filename" : fileName,
            "filesize" : fileSize,
            "categoryid": '13C96178565F993B',
            //"notifyurl" :"http://www.renrendonghua.com/rrbi/atta/video/callback",
          };

          $.ajax({
            url : "http://cclive.21teacher.com/ccvideo/uploadVideofront",
            async : false, //必须以同步的方式执行，否则后续操作拿不到接口返回的数据
            type : "post",
            data : d,
            cache : false,
            dataType : "json",
            contentType : "application/x-www-form-urlencoded; charset=UTF-8",
            error : function() {
              video = {
                "errMsg" : "获取视频文件vid出错",
                "errorType" : "network"
              };
            },
            success : function(data) {
              if(data.errMsg){
                video.errMsg = "获取视频文件vid出错";
                return;
              }
              video.success = true;
              video.uid = data.videoUploadInfo.userid;
              video.ccvid = data.videoUploadInfo.videoid;
              video.servicetype = data.videoUploadInfo.servicetype;
              video.name = fileName;
              video.uri = data.videoUploadInfo.chunkurl;
              video.metauri = data.videoUploadInfo.metaurl;
              video.size = fileSize;

              this_.videoCcId = data.videoUploadInfo.videoid

              this_.video.video_id =  data.videoUploadInfo.videoid

              this_.uploadchunk = data.videoUploadInfo.chunkurl+"?ccvid="+data.videoUploadInfo.videoid;
            }
          });
          return video;
        }
      });
    },

    clearHtml(){

    },
    //停止上传
    stopUploadVideo () {
      let this_ = this
      if(this_.videoCcId.length > 5){
        utilAPi.videoDelete(this_.videoCcId).then(re => {
          //console.log("停止上传")
          this_.videoCcId=''
          this_.videoName=''
          this_.dialogUploadVideo = false
          this_.processLenghth=0
        })
      }
    },
    closeVideoDialog(){
      let processLenghth = this.processLenghth
      $('.pauseObj').attr('style', '');
      $('.resumeObj').attr('style', 'display:none');
      if(processLenghth==100){
        //this.finishedUploadVideo()
      }else{
        this.stopUploadVideo()
      }

    },
    //完成上传
    finishedUploadVideo () {
      let thiss =this

      $('.resumeObj').attr('style', 'display:none');

      tinymce.activeEditor.insertContent('<iframe id="cciframe_'+thiss.video.video_id+'" src="https://p.bokecc.com/playhtml.bo?vid='+thiss.video.video_id+'&siteid=9D23FB9C216EB7C0&autoStart=true&playerid=AB4A28055BBF9E34&playertype=1&isShare=true&newversion=true" allowfullscreen="true" frameborder="0" height="490" width="90%"></iframe>')
      thiss.dialogUploadVideo = false
      thiss.processLenghth=0
    },
    getVal(){
        //return this.content
        //console.log("----------------------",this.content)
    }
  }
}
</script>

<style scoped lang="less">
.que-richtext{
  .richtext-title{
    padding: 10px 15px;
    height: 52px;
    font-size: 0;
    border-bottom: 2px solid #f7f7f7;
    background: #fff;
    li{
      float: left;
      margin: 0 5px;
      i{
        display: block;
        width: 30px;
        height: 30px;
        background-position: center center;
        background-repeat: no-repeat;
        cursor: pointer;
      }
      &:first-child{
        i{
          background-image: url('../../../assets/images/richtext_001.jpg');
        }
      }
      &:nth-child(2){
        i{
          background-image: url('../../../assets/images/richtext_002.jpg');
        }
      }
      &:nth-child(3){
        i{
          background-image: url('../../../assets/images/richtext_003.jpg');
        }
      }
      &:nth-child(4){
        i{
          background-image: url('../../../assets/images/richtext_004.jpg');
        }
      }
      &:nth-child(5){
        i{
          background-image: url('../../../assets/images/richtext_005.jpg');
        }
      }
      &:nth-child(6){
        i{
          background-image: url('../../../assets/images/richtext_006.jpg');
        }
      }
      &:nth-child(7){
        i{
          background-image: url('../../../assets/images/richtext_007.jpg');
        }
      }
    }
  }
  .rich-cont{
    /deep/textarea{
      padding: 15px;
      letter-spacing: 2px;
      line-height: 22px;
      color: #808080;
      font-size: 15px;
      border: none;
    }
  }

}
</style>
